import { Components, Theme } from '@mui/material/styles';

export const accordionSummaryTheme: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    // Dense accordion header matching the app-wide small input height.
    root: ({ theme }) => ({
      minHeight: theme.spacing(5),
      "&.Mui-expanded": {
        minHeight: theme.spacing(5),
      },
    }),
    content: ({ theme }) => ({
      margin: theme.spacing(1, 0),
      "&.Mui-expanded": {
        margin: theme.spacing(1, 0),
      },
    }),
  },
};
